import React from "react";
import { Box, Typography, Grid, Container } from "@mui/material";
import { motion } from "framer-motion";

const cardVariants = {
  hidden: { opacity: 0, y: 50 }, // يبدأ مخفيًا ومنخفضًا
  visible: { 
    opacity: 1, 
    y: 0, 
    transition: { duration: 0.6, ease: "easeInOut" } 
  },
};

const Target = () => {
  const services = [
    {
      img: "/travel1.webp",
      title: "Stress-Free Travel Arrangements",
      description:
        "Our services are designed for individuals and families seeking stress-free travel arrangements, including visa documentation and curated vacation packages for destinations around the world.",
    },
    {
      img: "/travel3.webp",
      title: "Business Travel Services",
      description:
        "We cater to professionals who require efficient visa processing and seamless travel services for business trips, conferences, meetings, and corporate events.",
    },
    {
      img: "/travel2.webp",
      title: "Services for Travel Agencies & Large Groups",
      description:
        "We serve travel agencies, tour operators, and large groups by providing visa services and organizing travel logistics, ensuring hassle-free trips for groups of any size.",
    },
  ];

  return (
    <Container>
      <Box sx={{ padding: "40px 0" }}>
        <Grid container spacing={4} justifyContent="center">
          {services.map((service, index) => (
            <Grid item xs={12} md={4} key={index}>
              <motion.div
                variants={cardVariants}
                initial="hidden"
                whileInView="visible" // تتحرك عند الدخول إلى الشاشة
                viewport={{ amount: 0.3 }} // تتكرر عند التمرير للأعلى والأسفل
                style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
              >
                <img
                  src={service.img}
                  alt={service.title}
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "8px",
                    marginBottom: "20px",
                  }}
                />
                <Typography
                  variant="h5"
                  sx={{
                    color: "primary.main",
                    fontFamily:'Emirates',
                    
                    textAlign: "center",
                  }}
                >
                  {service.title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    marginTop: "20px",
                    fontSize: "1.2rem",
                    lineHeight: 1.8,
                    color: "text.primary",
                    textAlign: "left",
                    maxWidth: "320px",
                    fontFamily:'Emirates',

                  }}
                >
                  {service.description}
                </Typography>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default Target;
